<script setup>
import { ref, defineProps, computed, onMounted, onUnmounted, defineEmits } from 'vue';
const $emit = defineEmits(['updateInfoBoxBottom']);
const props = defineProps({
    infoBoxBottomData: Object,
    closeHandle: Function,
});

const scrollBox = ref(null);

const scrollNoticeVisible = ref(true);

// const scrollNoticeVisible = computed(()=>{
//     return scrollBox.value? scrollBox.value.scrollHeight > scrollBox.value.clientHeight : false;
// })

let timeout;

onMounted(() => {

    timeout = setTimeout(() => {
        scrollNoticeVisible.value = scrollBox.value.scrollHeight > scrollBox.value.clientHeight;
    }, 10)


    scrollBox.value.addEventListener("scroll", (event) => {

        if ((scrollBox.value.scrollHeight - scrollBox.value.offsetHeight - scrollBox.value.scrollTop) < 1) {
            // 滑到底部
            scrollNoticeVisible.value = false;
        }

    });
});

onUnmounted(() => {
    clearTimeout(timeout);
})

const okClick = () => {
    // props.infoBoxBottomData.read = true;
    $emit('updateInfoBoxBottom');
    if (props.closeHandle) {
        props.closeHandle();
    }
}

</script>

<template>

    <div class="fixed top-0 left-0 right-0 bottom-0 z-40 bg-[#0204167A]">
        <div class="post-content relative">
            <div class="flex flex-col absolute top-[10%] bottom-0 w-full bg-white rounded-t-lg">
                <div>
                    <div class="flex justify-between p-4 max-w-[768px] mx-auto">
                        <div class="flex-1">
                            <h5 class="text-lg font-bold text-left pb-2" v-if="infoBoxBottomData?.title">{{
                                infoBoxBottomData.title }}</h5>
                        </div>
                        <div>
                            <button @click="(e) => { closeHandle(); }">
                                <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                    style="width: 24px;height: 24px;">
                                    <title>close</title>
                                    <path
                                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="flex-1 p-4 relative">
                    <div class="p-4 absolute top-0 bottom-0 left-0 right-0">
                        <div class="max-w-[768px] mx-auto flex flex-col h-full relative">

                            <div class="flex-1 overflow-y-auto scroll-smooth bg-[#EEF0F0] rounded-md" ref="scrollBox">

                                <div class="p-6" v-if="infoBoxBottomData?.content">
                                    <template v-if="typeof infoBoxBottomData.content === 'string'">
                                        <span v-html="infoBoxBottomData.content" />
                                    </template>
                                    <template v-else-if="typeof infoBoxBottomData.content === 'object'">
                                        <div class="flex" v-for="items in infoBoxBottomData.content">
                                            <div v-for="item in items"> {{ item }} </div>
                                        </div>
                                    </template>
                                </div>

                            </div>
                            <div class="py-1 px-4 absolute left-1/2 -translate-x-1/2 bottom-[86px] bg-[#020416B8] rounded-full text-white text-sm"
                                v-show="scrollNoticeVisible">
                                <div class="inline-block align-middle">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        width="16" height="16">
                                        <title>arrow-down</title>
                                        <path d="M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z" />
                                    </svg>
                                </div>
                                捲至最底
                            </div>
                            <div class="pt-6">
                                <button
                                    class="p-3 w-full rounded-md bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                                    :disabled="scrollNoticeVisible" @click="okClick">本人已閱讀並同意
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
    .post-content {
        min-height: 100vh;
    }

    @supports (height: 100dvh) {
        .post-content {
            min-height: 100dvh;
        }
    }
</style>
